import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common components
import {
  Button,
  TextInput,
  FullScreenLoading,
  StaticDropdown,
  DynamicDropdown,
} from "src/Components";
// Requests
import {
  getConversionConfig,
  setConversionConfig,
  getHedgerOptionInstruments,
} from "src/Requests/automaticMarketMaking";
import { getBaseInstruments } from "src/Requests/Order/tradeTableRequests";
// Types
import {
  IBaseConversionItems,
  IConversionConfigDto,
  IConversionProfitType,
} from "src/Interfaces/automaticMarketMaking";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  onClose: () => void;
}
const ConfigModal: React.FC<IProps> = ({ onClose }) => {
  // local store
  const [loading, setLoading] = React.useState(false);
  const [config, setConfig] = React.useState({
    baseConversionItems: [] as IBaseConversionItems[],
  } as IConversionConfigDto);

  React.useEffect(() => {
    setLoading(true);
    getConversionConfig()
      .then((resp) => {
        setConfig(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const conversionProfitTypeOptions: DropdownItem[] = [
    { id: IConversionProfitType.Auto, name: "اتوماتیک" },
    { id: IConversionProfitType.SemiAuto, name: "نیمه اتوماتیک" },
    { id: IConversionProfitType.Manual, name: "دستی" },
  ];

  const instrumentChangeHandler = (insId: string, name: string, value: any) => {
    const targetIndex = config.baseConversionItems.findIndex(
      (f) => f.baseInsId === insId
    );
    if (targetIndex === -1) return;
    const clone = [...config.baseConversionItems];
    clone.splice(targetIndex, 1, {
      ...config.baseConversionItems[targetIndex],
      [name]: value,
    });
    setConfig({
      ...config,
      baseConversionItems: [...clone],
    });
  };

  const changeHandler = (name: string, value: any) => {
    setConfig({ ...config, [name]: value });
  };

  const setConfigHandler = () => {
    setLoading(true);
    setConversionConfig(config)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="w-full flex flex-col justify-start items-center gap-5">
      {loading ? <FullScreenLoading /> : <></>}
      <div className="w-full grid grid-cols-4 gap-x-5 gap-y-3">
        <div>نماد پایه</div>
        <div>نوع تعیین بازده کانورژن</div>
        <div>معیار کانورژن</div>
        <div>٪ بازده کانورژن دستی</div>
        {config &&
        config.baseConversionItems &&
        config.baseConversionItems.length ? (
          config.baseConversionItems.map((ins) => (
            <>
              <div>{ins.baseInsName}</div>
              <StaticDropdown
                dropdown={{
                  name: "conversionProfitType",
                  placeholder: "نوع تعیین بازده کانورژن",
                }}
                options={conversionProfitTypeOptions}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseInsId, ...props)
                }
                value={ins?.conversionProfitType}
              />
              <DynamicDropdown
                dropdown={{
                  name: "conversionRef",
                  placeholder: "معیار کانورژن",
                  disabled:
                    ins?.conversionProfitType !==
                    IConversionProfitType.SemiAuto,
                }}
                getData={() => getHedgerOptionInstruments(ins.baseInsId)}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseInsId, ...props)
                }
                value={ins?.conversionRef}
              />
              <TextInput
                disabled={
                  ins?.conversionProfitType !== IConversionProfitType.Manual
                }
                label="٪ بازده کانورژن دستی"
                name="manualConversionProfit"
                value={ins.manualConversionProfit?.toString()}
                onChange={(...props) =>
                  instrumentChangeHandler(ins.baseInsId, ...props)
                }
                kind="percent"
              />
            </>
          ))
        ) : (
          <></>
        )}
      </div>
      <div className="w-[100px] mr-auto">
        <Button onClick={setConfigHandler} text="ثبت" variant="contained" />
      </div>
    </div>
  );
};

export default ConfigModal;
